module.exports = __webpack_public_path__ + "static/media/qr-code.4a6273ab.jpg";